import { render, staticRenderFns } from "./a4PrintPaper.vue?vue&type=template&id=c0fe0140&scoped=true"
import script from "./a4PrintPaper.vue?vue&type=script&lang=js"
export * from "./a4PrintPaper.vue?vue&type=script&lang=js"
import style0 from "./a4PrintPaper.vue?vue&type=style&index=0&id=c0fe0140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fe0140",
  null
  
)

export default component.exports